<template>
  <div class>
    <slot></slot>

    <button class="modify-button" type="button" @click="save">
      저장
    </button>

    <button class="cancel-button" type="button" @click="cancel">
      취소
    </button>

  </div>
</template>

<script>
export default {
  name: 'DetailRowWrapper',
  props: {
    saveFunction: Function,
    cancelFunction: Function,
  },
  methods: {
    save() {
      this.saveFunction();
    },

    cancel() {
      this.cancelFunction();
    },
  },
};
</script>

<style lang="scss" scoped>
.modify-button {
  margin-left: 50px;
  margin-top: 25px;
  margin-bottom: 25px;
  background-color: rgb(0, 181, 173);
  border: rgb(0, 181, 173) 1px solid;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-size: 18px;
  padding: 0;
  width: 200px;
  height: 50px;
}

.cancel-button {
  margin-left: 50px;
  margin-top: 25px;
  margin-bottom: 25px;
  background-color: rgb(255, 127, 107);
  border: rgb(255, 127, 107) 1px solid;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-size: 18px;
  padding: 0;
  width: 200px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/detail-row/DetailRowWrapper.vue